import {match} from 'ts-pattern';

import type {QueryFilterObject} from 'features/eag-grid';

export type ConfigurationPreset =
  'all' | 'onOrder' | 'arrived' | 'waitingForConfirmation' | 'unassigned';

export function getConfigurationPresetFilter(
  preset: ConfigurationPreset,
  filter: QueryFilterObject
): QueryFilterObject {
  return match(preset)
    .with('all', () => filter)
    .with('onOrder', () => ({
      ...filter,
      orderStatus: ['ordered', 'in_production', 'in_transit'],
    }))
    .with('arrived', () => ({
      ...filter,
      orderStatus: ['arrived', 'ready_for_handover'],
    }))
    .with('waitingForConfirmation', () => ({
      ...filter,
      awaitingConfirmation: ['delivered', 'cancelled'],
    }))
    .with('unassigned', () => ({
      ...filter,
      businessCaseUnassigned: true,
      vehicleUnassigned: true,
    }))
    .exhaustive();
}
